'use strict';

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var themeProvider_themeProvider = require('../../theme-provider/theme-provider.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент контента сайта.
 */
var Content = /** @class */ (function (_super) {
    tslib.__extends(Content, _super);
    function Content() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('content');
        return _this;
    }
    Content.prototype.render = function () {
        var _a = this.props, _b = _a.view, view = _b === void 0 ? 'default' : _b, theme = _a.theme, tableMode = _a.tableMode, children = _a.children, id = _a.id;
        return (React__default.default.createElement(themeProvider_themeProvider, { theme: theme },
            React__default.default.createElement("div", { className: this.cn({
                    default: view === 'default',
                    corp: view === 'corp',
                    table: tableMode,
                }), id: id, "data-test-id": this.props['data-test-id'] }, children)));
    };
    return Content;
}(React__default.default.Component));

module.exports = Content;
